module.exports = __webpack_public_path__ + "学术圈.png?e6829b4bf79bbf14a7092a8fa336f1ed";


//////////////////
// WEBPACK FOOTER
// ./src/assets/学术圈.png
// module id = 638
// module chunks = 0